import Property from './Properties';
export default Property;